import { Link } from "react-router-dom";
import { GraduationCap, Video, Ticket, Library, TrendingUp, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

const EDU = "https://images.pexels.com/photos/34046711/pexels-photo-34046711.jpeg";

const PERKS = [
  { icon: Video, t: "Host paid sessions", d: "Run Zoom or video-based lessons and masterclasses." },
  { icon: Ticket, t: "Sell event tickets", d: "Set your price. Keep 70–80% of every sale." },
  { icon: Library, t: "Replay library", d: "Offer on-demand access to past sessions." },
  { icon: TrendingUp, t: "Authority positioning", d: "Get featured as an educator and promote courses or books." },
];

export default function Events() {
  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <img src={EDU} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/50" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-28">
          <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-4">Education & Events</p>
          <h1 className="font-display text-4xl md:text-6xl font-bold max-w-3xl">Get paid to teach your craft.</h1>
          <p className="mt-6 text-neutral-300 max-w-xl">Educators host live classes, sell tickets, build authority, and earn from expertise. Barbistry takes a 20–30% platform fee; you keep the rest.</p>
          <Link to="/register" className="inline-block mt-8">
            <Button className="rounded-none bg-[#D4AF37] text-black hover:bg-[#F0C84B] font-semibold h-12 px-8" data-testid="events-apply">Apply as Educator</Button>
          </Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PERKS.map((p) => (
            <div key={p.t} className="bg-[#111] border border-white/10 p-7 hover:border-[#D4AF37]/40 transition-colors">
              <p.icon className="text-[#D4AF37]" size={24} />
              <h3 className="mt-5 font-display text-lg font-semibold">{p.t}</h3>
              <p className="mt-2 text-sm text-neutral-400">{p.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          <div className="border border-white/10 bg-[#0a0a0a] p-8">
            <h2 className="font-display text-2xl font-bold">Revenue model</h2>
            <div className="mt-6 space-y-4">
              <div className="flex items-center justify-between border-b border-white/10 pb-3">
                <span className="text-neutral-300">Educator payout</span>
                <span className="font-mono text-2xl text-[#D4AF37]">70–80%</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-neutral-300">Barbistry platform fee</span>
                <span className="font-mono text-2xl text-neutral-400">20–30%</span>
              </div>
            </div>
            <p className="mt-6 text-sm text-neutral-500">Payouts follow the Educator / Event Host Agreement, subject to refunds and chargebacks.</p>
          </div>

          <div className="border border-[#D4AF37]/30 bg-[#111] p-8 flex flex-col">
            <Lock className="text-[#D4AF37]" size={22} />
            <h2 className="mt-4 font-display text-2xl font-bold">Member-only education</h2>
            <p className="mt-3 text-neutral-300 flex-1">Premium product breakdowns, deeper business lessons, local growth tactics, and pricing strategy — reserved for paying members.</p>
            <Link to="/pricing" className="mt-6"><Button variant="outline" className="rounded-none border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 bg-transparent w-full" data-testid="events-see-plans">Unlock with membership</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
